import { Button, Space, Select, Col, InputNumber } from "antd";
import { useEffect, useState } from "react";

import { DeleteFilled } from "@ant-design/icons";
import { currencycodes } from "../../utils";

const RentalsPricingInput = ({ value = {}, onChange, form, fieldName }) => {
  // for all codes
  //const codes = Object.keys(currencycodes );
  const codes = ["INR", "BDT", "GBP", "NPR", "MUR", "SGD", "AED", "EUR", "USD"];
  const defaultmap = {
    INR: 1,
    USD: 1,
    EUR: 1,
    SGD: 1,
    AED: 1,
    NPR: 1,
    MUR: 1,
    BDT: 1,
    GBP: 1,
  };
  const [result, setResult] = useState({});
  const [oldKey, setOldKey] = useState("");
  const data = form.getFieldValue("price");
  const triggerChange = (result, op) => {
    if (op === "select") delete result[""];
    result = { ...defaultmap, ...result };
    form.setFieldsValue({ [fieldName]: result });
    onChange?.({ ...result });
  };
  useEffect(() => {
    let tempResult = { ...defaultmap, ...data };
    // console.log("prices - ", data);
    setResult(tempResult);
    if (data && Object.keys(data).length < 7) triggerChange(tempResult);
  }, [data]);

  const handleNumberChange = (value, code) => {
    // console.log(value, code);
    let t = { ...result, [code]: value };
    setResult(t);
    triggerChange(t, "number");
  };

  const handleMrpChange = (value, code) => {
    // console.log(value, code);
    let t = { ...result, [code]: value };
    setResult(t);
    triggerChange(t, "number");
  };

  return (
    <>
      {codes.map((code, _) =>
        code !== undefined ? (
          <>
            <Space direction="horizontal" style={{ width: "100%" }}>
              <Select
                showSearch
                optionFilterProp="children"
                id={`${code}-select`}
                value={code}
                onDropdownVisibleChange={(open) => {
                  if (open) {
                    setOldKey(code);
                  }
                }}
                onChange={(_, option) => {
                  let t = {};
                  t[option.key] = result[code];
                  delete result[oldKey];
                  setResult({ ...result, ...t });
                  triggerChange({ ...result, ...t }, "select");
                }}
                style={{
                  width: "200px",
                  margin: "0 8px",
                }}
              >
                <Select.Option key={""} value={""} label={""}>
                  {""}
                </Select.Option>
                {codes.map((cc) => (
                  <Select.Option key={cc} value={cc} disabled={cc in result}>
                    {currencycodes[cc]}
                  </Select.Option>
                ))}
              </Select>
              <InputNumber
                width={"150px"}
                type={"number"}
                key={code}
                min={1}
                max={9999}
                value={result[code]}
                defaultValue={result[code]}
                onChange={(value) => handleNumberChange(value, code)}
                style={{ width: 100 }}
              />
            </Space>
            <br />
          </>
        ) : null
      )}
    </>
  );
};

export default RentalsPricingInput;
